import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { track } from "@/lib/track";

export default function Layout() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
    track("pageview", pathname);
  }, [pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-ink-0 text-parchment" data-testid="app-layout">
      <Navbar />
      <main className="flex-1" data-testid="page-main">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
